import React from "react";
import * as Icon from "react-feather";
import WComponent from "../../../../../../../common/WComponent";

class MappingProposal extends WComponent {
	state = { mapped: false };

	render() {
		let { mapping, onApprove } = this.props;
		let { mapped } = this.state;

		// Show clean account name, hide canonical code paths
		let fromLabel = mapping.accountName || mapping.accountNumber;
		let toLabel = mapping.canonicalName;
		let hasRealAccountNumber = mapping.accountNumber && !mapping.accountNumber.includes(".");

		if (mapped) {
			return (
				<div className="afs-review__mapping afs-review__mapping--done">
					<Icon.CheckCircle size={16} color="#2e7d32" />
					<span className="afs-review__mapping-confirmed">{fromLabel} mapped to {toLabel}</span>
				</div>
			);
		}

		return (
			<div className="afs-review__mapping">
				<div className="afs-review__mapping-visual">
					<div className="afs-review__mapping-from">
						<span className="afs-review__mapping-label-small">From</span>
						<span className="afs-review__mapping-account">{fromLabel}</span>
						{hasRealAccountNumber && <span className="afs-review__mapping-code">Acct {mapping.accountNumber}</span>}
					</div>
					<div className="afs-review__mapping-arrow">
						<Icon.ArrowRight size={18} color="#999" />
					</div>
					<div className="afs-review__mapping-to">
						<span className="afs-review__mapping-label-small">To</span>
						<span className="afs-review__mapping-account">{toLabel}</span>
					</div>
				</div>
				<button className="afs-review__exec-proposal-approve" onClick={() => {
					if (onApprove) onApprove();
					this.update({ mapped: true });
				}}>
					<Icon.Check size={14} /> Map Account
				</button>
			</div>
		);
	}
}

export default MappingProposal;
